export default __webpack_public_path__ + "static/media/Top Logo.e8c437e5.png";